import { StripeProductBoardUpdateTemplateFromJSON, StripeProductBoardUpdateTemplateToJSON, } from './StripeProductBoardUpdateTemplate';
/**
 * Check if a given object implements the UpdateStripeProducBoardRequest interface.
 */
export function instanceOfUpdateStripeProducBoardRequest(value) {
    let isInstance = true;
    isInstance = isInstance && "template" in value;
    return isInstance;
}
export function UpdateStripeProducBoardRequestFromJSON(json) {
    return UpdateStripeProducBoardRequestFromJSONTyped(json, false);
}
export function UpdateStripeProducBoardRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'template': StripeProductBoardUpdateTemplateFromJSON(json['template']),
    };
}
export function UpdateStripeProducBoardRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'template': StripeProductBoardUpdateTemplateToJSON(value.template),
    };
}
